import  font from './Korean-3';
export default (pdf) => {
  pdf.addFileToVFS('bolds', font);
  return true;
}
